<template lang="pug">
span

  v-btn(
    @click="showModalHandler" 
    :loading="loading"
    small
    color="primary"
    outlined
  ) Overmaking aanbetaling herkanser
  confirmation-dialog(
    v-model="modalShowing"
    :title="modalTitle"
    :descr="modalText"
    @okBtnClicked="send"
    @failBtnClicked="reset"
    @click:outside="reset"
  )
</template>

<script>
import ErrMixin from "@/mixins/errors.mixin"
import { CBR_STATUS } from '../core/candidates-const'
export default {
  name: 'CandidateRemoveFromAcceptance',
  mixins: [ErrMixin],
  inject: ['svc'],

  props: {
    disabled: Boolean,
    ID: Number,
    status: String
  },

  data: () => ({
    loading: false,
    modalTitle: 'Overmaking aanbetaling herkanser',
    modalText: 'Are you sure you want to restore this Candidate?',
    modalShowing: false
  }),

  computed: {
    Svc() {
      return this.svc()
    },

    disabledAction() {
      if(this.disabled) return true
      if(this.status !== CBR_STATUS.ARCHIVED) return true
      return false
    }

  },

  methods:{ 
    showModalHandler() {
      this.showConfirmation()
    },

    showConfirmation() {
      this.freeze()
      this.modalShowing = true
    },

    async send() {
      this.freeze()
      try {
        await this.Svc.restore(this.ID)
        this.unFreeze()
      } catch (error) {
        this.processError(error, {redirectName: this.$ROUTER_NAMES.LOGIN_CRM})
      }
      finally {
        this.unFreeze()
      }
    },

    freeze() {
      this.loading = true
    },

    unFreeze() {
      this.loading = false
    },

    reset() {
      this.unFreeze()
    }
  },

  components: {
    confirmationDialog: () => import('@/components/global/ConfirmationDialog.vue')
  }
}
</script>